import { IUser, Permission } from './interfaces';

export const hasPermission = (u?: IUser | null, p?: Permission) =>
  !!u?.isAdmin &&
  (u.isSuperAdmin === true || (!!p && u.permissions?.includes(p)));

export const isSuperAdmin = (u?: IUser | null) =>
  !!u?.isAdmin && !!u?.isSuperAdmin;
